<template lang="pug">
v-container.View.View--Login
  v-card
    v-snackbar(top v-model="showSnackbar" :color="resetSuccess" :timeout="5000")
      | {{ resetOutcome }}
      v-btn(dark text @click="showSnackbar = false") Ok
    v-card-text.pt-4
      .subtitle-1.text-center Fai il login per accedere a tutti i servizi
      ValidationObserver(v-slot="{ invalid, validated, passes }")
        v-form
          v-layout(wrap)
            DevelopmentContainer(v-if="false")
              v-btn(@click="devFillForm") Fill Form
            v-flex(xs12)
              ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                v-text-field(
                  v-model="form.email" required
                  :error-messages="errors"
                  name="e-mail" type="email"
                  label="Email" prepend-inner-icon="mdi-at"
                )
            v-flex(xs12)
              ValidationProvider(name="Password" rules="required" v-slot="{ errors }")
                v-text-field(
                  v-model="form.password" required
                  :error-messages="errors"
                  name="password" type="password"
                  label="Password" prepend-inner-icon="mdi-asterisk"
                )
            v-flex(xs12)
              .text-center
                v-btn.secondary.px-6(
                  @click="passes(login)" :disabled="invalid || !validated"
                  :loading="loading"
                  rounded block
                ) Login
            v-flex(xs12)
              div.mt-2.text-center Hai dimenticato la password?
                a.pl-1(@click="showResetPassword = true") Clicca qui
      v-divider.my-3
  .px-3.py-5.text-center
    .headline.mb-2 Sei un nuovo utente?
    v-layout(wrap)
      v-flex(xs12)
        v-btn.primary(rounded :to="{ name: 'auth.register' }") Registrati
  v-dialog(v-model="showResetPassword" eager max-width="720px")
    ValidationObserver(v-slot="{ invalid, validated, passes }")
      v-card
        v-card-title.headline Stai per richiedere il reset della password...
        v-card-text
          | Inserisci l'indirizzo email dell'account per il quale vuoi richiedere la password
          v-flex(xs12 data-vv-scope='reset')
            ValidationProvider(name="Email" rules="required|email" immediate v-slot="{ errors }")
              v-text-field(
                v-model="form.email" required
                :error-messages="errors"
                name="email" type="email"
                label="Email" prepend-inner-icon="mdi-at"
              )
          v-flex(xs12)
            div(id="recaptcha-reset")
        v-card-actions
          v-btn(text @click="showResetPassword = false") Annulla
          v-spacer
          v-btn.primary(@click="passes(resetPassword)" :disabled="invalid || !validated") Reset Password
</template>

<script>
import DevelopmentContainer from "@/components/DevelopmentContainer";
import Merchant from "@/api/Merchant";

export default {
  components: { DevelopmentContainer },

  props: {
    passwordReset: {
      default: false
    },
    after: {
      default: null
    }
  },

  data: () => ({
    form: {
      email: "",
      password: ""
    },

    loading: false,
    showSnackbar: false,
    showResetPassword: false,
    resetOutcome: "Reset della password richiesto",
    resetSuccess: "success",

    recaptchaWidget: null,
    recaptchaToken: null
  }),

  computed: {
    restaurant() {
      return this.$store.state.restaurant;
    }
  },

  created() {
    if (this.passwordReset) {
      this.showSnackbar = true;
      this.resetOutcome = "Password resettata con successo";
    }
  },

  mounted() {
    // Prevent navigation if already logged in
    if (this.$auth.check()) {
      this.goBack();
      return;
    }

    this.$nextTick(() => {
      this.recaptchaWidget = window.renderRecaptcha("recaptcha-reset");
    });

    this.$emit("update:title", "Login Azienda");
  },

  methods: {
    async login() {
      this.loading = true;

      try {
        await this.$auth.login({
          username: this.form.email,
          password: this.form.password
        });
      } catch (error) {
        this.loading = false;
        throw error;
      }

      this.loading = false;
      this.goBack();
    },

    devFillForm() {
      this.form.email = "test@test.it";
      this.form.password = "ipratico";
    },

    goBack() {
      if (this.after) {
        this.$router.replace({ name: this.after });
        return;
      }

      this.$router.push({ name: "home" });
    },

    async resetPassword() {
      this.getRecaptchaResponse();
      if (!this.recaptchaToken) return;

      this.loading = true;
      try {
        await Merchant.requestResetPassword({
          email: this.form.email,
          "g-recaptcha-response": this.recaptchaToken
        });
      } catch (error) {
        window.grecaptcha.reset();
        throw error;
      } finally {
        this.loading = false;
      }
      this.showSnackbar = true;
      this.showResetPassword = false;
    },

    getRecaptchaResponse() {
      this.recaptchaToken = window.grecaptcha.getResponse(this.recaptchaWidget);
    }
  }
};
</script>
